import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class resourceModel extends Model {

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'view',
			file_name: '',
			title: '',
			id: 0,
			data: {
				interpreter_resource_id: 0
			},
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				view: 'GET',
				detail: 'GET',
				menu: 'GET',
				resourceReadSeen: 'POST',
			}
		}
	}

	routes() {
		return {
			view: 'interpreter/resources/get_image?token=',
			detail: 'interpreter/resources/detail/{id}',
			menu: 'interpreter/resources/menu',
			resourceReadSeen: 'interpreter/resources/readSeen'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	getDetail(id) {
		this.id = id;
		this.methodTypes = 'detail';
		return this.requestRoute();
	}

	getResourceMenu() {
		this.methodTypes = 'menu';
		return this.requestRoute();
	}

	saveAsReadSeen() {
		this.methodTypes = 'resourceReadSeen';
		return this.requestRoute();
	}
}
